import { LocationDetails, TwilioVerificationChannelEnum, UseToggleType } from '@alluradirect/react';
import { Typography, Box } from '@mui/material';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import Grid from 'components/core/Grid';
import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';
import { FormikAddress } from 'components/formik/core/FormikAddress/FormikAddress';
import FormikDateOfBirth from 'components/formik/core/FormikDateOfBirth/FormikDateOfBirth';
import FormikPhoneNumber from 'components/formik/core/FormikPhoneNumber/FormikPhoneNumber';
import { SignupAccountDetailsFormikValues } from 'components/views/pages/signup/SignupAccountDetails';
import { VerificationDialog, VerificationStepEnum } from 'components/views/verification/VerificationDialog';
import { useFormikContext } from 'formik';

interface Props {
  locationDetails: LocationDetails;
  togglePhoneVerification: UseToggleType;
  hasTopAppDivider?: boolean;
  onVerificationSuccess: (vals: SignupAccountDetailsFormikValues, setSubmitting: any) => Promise<void>;
  guestId: string | undefined;
}

export const SignupAccountDetailsForm = ({
  locationDetails,
  togglePhoneVerification,
  hasTopAppDivider = true,
  onVerificationSuccess,
  guestId,
}: Props) => {
  const {
    values,
    handleSubmit,
    isSubmitting,
    isValid,
    setSubmitting,
  } = useFormikContext<SignupAccountDetailsFormikValues>();

  return (
    <Grid container spacing={2}>
      {hasTopAppDivider ? (
        <Grid item xs={12}>
          <AppDivider />
        </Grid>
      ) : null}

      <FormikAddress formikPrefix={''} locationDetails={locationDetails} />

      <Grid item xs={12}>
        <AppDivider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1">Phone Number</Typography>
      </Grid>
      <Grid item xs={12}>
        <FormikPhoneNumber name="PHONE" />
      </Grid>

      <Grid item xs={12}>
        <AppDivider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1">Date of Birth</Typography>
        <FormikDateOfBirth fieldPrefix={'DOB'} />
        <Box sx={{ paddingTop: 1 }}>
          <Typography variant="caption">
            Date of birth may be required for properties that have minimum age restrictions, but is not shared with the
            host. This age must match your government issued identification.
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <LoadingButton
          isDisabled={!isValid}
          isLoading={isSubmitting}
          text="continue"
          isFullWidth
          onClick={() => handleSubmit()}
          isFormikButton={isValid}
        />
      </Grid>

      {togglePhoneVerification.isOpen ? (
        <VerificationDialog
          isOpen={togglePhoneVerification.isOpen}
          handleClose={togglePhoneVerification.close}
          initialData={values.PHONE}
          channel={TwilioVerificationChannelEnum.sms}
          onVerifySuccess={() => onVerificationSuccess(values, setSubmitting)}
          initialStep={VerificationStepEnum.VerifyCode}
          userId={Number(guestId as string)}
        />
      ) : null}
    </Grid>
  );
};
